import React, { useState, useEffect } from "react";
import TopHeading from "../Heading/TopHeading";
import { Button } from "react-bootstrap";
import UserChildrenBox from "../Children/UserChildrenBox";
import { Link } from "react-router-dom";
import axios from "../../axios";
import { toast } from "react-toastify";
import { Loader, NoContent } from "../UI";

export default function UserDashboardContent() {
  const authToken = localStorage.getItem("access_token");
  const [userChildren, setUserChildren] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem("user"));

  const fetchChildren = () => {
    axios
      .get("/user-children", {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data) {
          setUserChildren(response.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        toast.error("Couldn't load children");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchChildren();
  }, []);

  return (
    <section className="user-dashbaord-content">
      <div className="container">
        <div className="row g-0">
          <div className="col-md-12">
            <TopHeading title={`Hey ${user[0].firstName}`} />
            <div className="my-children light-bg corner-radius p-4 mb-3 custom-scrollbar">
              <div className="d-flex justify-content-between mb-4">
                <h5 className="mb-0 me-2">My Children</h5>
                <Link to={"/children"} className="link-btn link-font-size">
                  View All
                </Link>
              </div>
              {isLoading ? (
                <Loader />
              ) : userChildren.length ? (
                <div className="row g-0">
                  {userChildren.slice(0, 4).map((item) => {
                    return <UserChildrenBox data={item} key={item.childId} />;
                  })}
                </div>
              ) : (
                <NoContent />
              )}
              {userChildren.length > 4 && (
                <p className="mb-0 me-2 text-end text-muted">
                  Showing 4/{userChildren.length}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
